import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { SpecialSettingsStore } from '../../common/stores/special-settings.store';

const showCompanyNameSettingsKey = 'show-company-name-settings';

@injectable()
export class ShowCompanyNameSettingsStore {
    @observable enabled: boolean | undefined = undefined;
    @observable loaded = false;

    constructor(
        @inject(SpecialSettingsStore) private readonly specialSettings: SpecialSettingsStore
    ) {
        makeObservable(this);
        this.loadShowCompanyNameSettings();
    }

    @action
    loadShowCompanyNameSettings = async () => {
        const settings = await this.specialSettings.getAsync<{ enabled?: boolean }>(
            showCompanyNameSettingsKey
        );
        runInAction(() => {
            this.enabled = settings?.enabled;
            this.loaded = true;
        });
    };
}
